import type { ReactNode } from 'react'

import { AppInsightsProvider } from './AppInsightsProvider'
import { ReduxProvider } from './ReduxProvider'
import { SidebarProvider } from './SidebarProvider'
import { ThemeProvider } from './ThemeProvider'

export const AppProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ThemeProvider>
      <ReduxProvider>
        <AppInsightsProvider>
          <SidebarProvider>{children}</SidebarProvider>
        </AppInsightsProvider>
      </ReduxProvider>
    </ThemeProvider>
  )
}
